import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequireIslandManagementAccess } from "@/libs/guard/admin-permission-guard";

const IslandAccessibilityList = lazy(
  () =>
    import(
      "@/features/admin-view/accessibility-management/pages/island-accessibility-list"
    )
);

const AddNewAccessibility = lazy(
  () =>
    import(
      "@/features/admin-view/accessibility-management/pages/add-new-accessibility"
    )
);

const EditAccessibility = lazy(
  () =>
    import(
      "@/features/admin-view/accessibility-management/pages/add-new-accessibility"
    )
);

export const timeSlotsRoutes: RouteObject[] = [
  {
    path: "/admin/time-slots",
    element: (
      <RequireIslandManagementAccess>
        <IslandAccessibilityList />
      </RequireIslandManagementAccess>
    ),
  },
  {
    path: "/admin/time-slots/add",
    element: (
      <RequireIslandManagementAccess>
        <AddNewAccessibility />
      </RequireIslandManagementAccess>
    ),
  },
  {
    path: "/admin/time-slots/edit/:id",
    element: (
      <RequireIslandManagementAccess>
        <EditAccessibility />
      </RequireIslandManagementAccess>
    ),
  },
];
